module.exports = __webpack_public_path__ + "img/notice-business.f09b1dd7.svg";